import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import common from 'src/styles/common.module.scss'
import styles from '../styles.module.scss'

export const TextHeaderPt = () => {
    return (
        <HighlightedText
            text="RESGATE SEU BÔNUS"
            highlights={[
                { word: 'RESGATE' },
                { word: 'SEU' },
                { word: 'BÔNUS' },
            ]}
            className={common.text_header}
        />
    )
}

export const TextLandPt = () => {
    return (
        <HighlightedText
            text=" bónus de 325% + 400 GIROS GRÁTIS"
            highlights={[{ word: '325%' }, { word: '+ 400' }]}
            breakAfterWords={['325% ']}
            className={styles.text_content}
        />
    )
}
